export default __webpack_public_path__ + "static/media/favicon.e0d9f1df.png";